import React from "react";
import { colorFromName } from "./avatarColor";

const Avatar = props => {
    const name = String(props.name || "").trim() || "?";
    const allInitials = name.split(" ").map(item => item.charAt(0).toUpperCase()).filter(Boolean);
    let initials = allInitials[0] || "?";
    if (allInitials.length > 1) {
        initials = `${initials}${allInitials[allInitials.length - 1]}`;
    }
    const colors = colorFromName(name);
    const size = props.size || 32;

    return (
        <>
            <span
                className={`avatar-${size}`}
                style={{
                    backgroundColor: colors.backgroundColor,
                    color: colors.color,
                }}
                title={name}
            >
                {initials}
            </span>
            &nbsp;
        </>
    );
};

export default Avatar;
